<template>
  <div id="comp-members" :class="`has-${this.memberCount}`">
    <div class="member-container" v-for="user in members" :key="user.userSeqId">
      <comp-profile
        :userInitial="user.nickname.split('')[0]"
        :profileImage="user.matchUserPhoto"
      ></comp-profile>
    </div>
  </div>
</template>

<script>
import CompProfile from './CompProfile';

export default {
  name: 'comp-members',
  props: {
    members: Array,
  },
  components: {
    CompProfile,
  },
  computed: {
    memberCount() {
      if (this.members.length < 4) {
        return this.members.length;
      }
      return 4;
    },
  },
};
</script>

<style lang="scss" src="../scss/comp-members.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompMembers.vue